module.exports = __webpack_public_path__ + "img/carousel03.7bc7ca17.png";